<template>
  <div style="width:100%;height:100%;">
    <qcDetailReportList
      v-if="qcDetailPageIndex===1"
    />
    <sessionList
      v-if="qcDetailPageIndex===2"
    />
  </div>
</template>

<script>
import qcDetailReportList from './qcDetailReportList'
import sessionList from './sessionList'
export default {
  name: 'qcDetailReport',
  data() {
    return {}
  },
  components: {
    qcDetailReportList, sessionList
  },
  computed: {
    qcDetailPageIndex() {
      return this.$store.state.user.qcDetailPageIndex
    }
  },
  destroyed() {
    this.$store.commit('user/setQcDetailPageIndex', { qcDetailPageIndex: 1 })
  }
}
</script>
